<script setup lang="ts">
import HtmlContent from '@features/flatpages/components/HtmlContent/HtmlContent.vue'

import { useFlatpagePage } from '@features/flatpages/composables/useFlatpagePage'
import { createSeoHead } from '@shared/nuxt/createSeoHead'

const route = useRoute()
const { $host } = useNuxtApp()

const { title, content, breadcrumbs, description } =
  await useFlatpagePage('terms_of_use')

useHead({
  title,
  ...createSeoHead(
    $host,
    {
      title,
      keywords: '',
      description,
    },
    route.fullPath,
    route.path,
  ),
})
</script>

<template>
  <div class="terms-of-use">
    <the-breadcrumbs
      class="terms-of-use__breadcrumbs"
      theme="dark"
      :domain="$host"
      :breadcrumbs="breadcrumbs"
    />

    <html-content :page-content="content" />
  </div>
</template>

<style scoped lang="scss">
.terms-of-use {
  padding: 42px 20px 40px 20px;

  @include media($bp-tablet) {
    padding: 60px 20px 40px 20px;
  }

  @include media($bp-desktop-mini) {
    padding: 80px 0 100px 0;
  }

  &__breadcrumbs {
    margin-bottom: 20px;
  }
}
</style>
